import {PersonDocumentType, PersonDocumentTypeRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {Stack, TableCell, Typography} from "@mui/material";
import {SoftChip} from "../../../../components/kit";
import {useApiManager} from "../../../../components/utils/api";
import React from "react";
import {isAutoExpiration, monthsLabel, REQUIRED_PERIOD_SHORT} from "./labels";

export const PersonDocumentTypeListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<PersonDocumentType> = {
		title: "Tipos de documento del personal",
		onClick: "/app/admin/employee/persondoctype",
		headers: [
			{title: "Nombre"},
			{title: "Qué pide al subirlo"},
		],
		decorator: (bean: PersonDocumentType) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					<Typography variant="body2" fontWeight={600}>{bean.name}</Typography>
				</TableCell>
				<TableCell>
					<Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
						{bean.requiredYearMonth && <SoftChip tone="info" label="Mes y año"/>}
						{bean.expirationMode === "MANUAL" && <SoftChip tone="warning" label="Fecha de caducidad"/>}
						{isAutoExpiration(bean) &&
							<SoftChip tone="warning" label={"Caduca a " + monthsLabel(bean.expirationMonths)}/>}
						{bean.requiredForAll && <SoftChip tone="success"
							label={"Obligatorio para toda la plantilla, " + REQUIRED_PERIOD_SHORT[bean.requiredPeriod || "ONCE"]}/>}
						{!bean.requiredYearMonth && (bean.expirationMode || "NONE") === "NONE" && !bean.requiredForAll &&
							<Typography variant="body2" color="text.disabled">Nada más</Typography>}
					</Stack>
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(PersonDocumentTypeRestControllerApiFactory);
			return ctrl.pagePersonDocumentType(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};